try {
  window.performance.mark("otto-components-init-start");
  /*                                                                   */
} catch (e) {}
